export default "__VITE_ASSET__Des0Prkv__"